module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (97).648e2378.jpg";